// Use of Cloudinary API to reduce weight of downloaded images
export const getLighterImageCloudinary = (url: string,width?: number, height?: number, quality?: number): string => {
  // Noinspection DuplicatedCode
  if (!url || !url.includes('res.cloudinary.com/') || url.includes('f_auto')) return url;
  // Start of actual image name, = after last / in url
  const imageNameIndex = url.lastIndexOf('image/upload/') + 'image/upload/'.length;
  if (imageNameIndex < 0) return url;
  const imageName = url.slice(imageNameIndex);
  const urlStart = url.slice(0, imageNameIndex);
  // You should start write parameters as after / and before image name !
  let cloudinaryParameters = 'c_limit,f_auto/';
  if (!!height && !!width) {
    cloudinaryParameters = `w_${width},h_${height},${cloudinaryParameters}`;
  } else {
    cloudinaryParameters = `w_auto,${cloudinaryParameters}`;
  }
  if (quality) {
    cloudinaryParameters = `q_${quality},${cloudinaryParameters}`;
  } else {
    cloudinaryParameters = `q_auto,${cloudinaryParameters}`;
  }
  return urlStart.concat(cloudinaryParameters, imageName);
};